import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NewAppointmentDialogComponent } from './dialogs/new-appointment/new-appointment.component';
import { BookingsDialogComponent } from './dialogs/bookings/bookings.component';
import { DataService } from './data.service';
import { Service, Venue } from './types';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'app';
  more = false;
  constructor(public dialog: MatDialog, public data: DataService) {}
  login() {}
  logout() {}

  book(service: Service, venue: Venue) {
    this.dialog
      .open(NewAppointmentDialogComponent, {
        data: {
          venueId: venue.description,
          serviceId: service.id,
          venueCapacity: venue.max,
          uid: this.data.uid,
          serviceTime: service.date,
        },
        width: '90%',
      })
      .afterClosed();
  }

  viewBookings(service: Service) {
    this.dialog
      .open(BookingsDialogComponent, {
        data: service,
        width: '90%',
      })
      .afterClosed();
  }
}
